import { RawWidgetsLayout } from '@types';

export const generateFallbackLayout = (): RawWidgetsLayout => {
  return {
    column1: [
      {
        widgetId: 'site-details',
        permissions: [],
        customData: '',
      },
    ],
    column2: [],
  };
};
